<template>
    <a
        v-if="externalLink"
        :href="externalLink"
        target="_blank"
        rel="noopener noreferrer"
    >
        <slot />
    </a>
    <NuxtLink
        v-else-if="internalLink?.length > 0"
        :to="pageLink"
    >
        <slot />
    </NuxtLink>
    <div v-else>
        <slot />
    </div>
</template>

<script setup>
const props = defineProps({
    internalLink: {
        type: [String, Object],
        default: null
    },
    externalLink: {
        type: String,
        default: null
    }
});

const pageLink = computed(() => {
    if (!props.internalLink?.[0]?.uri) {
        return null;
    }

    if (typeof props.internalLink?.[0]?.uri === 'string') {
        // if uri is relative, make it absolute by prepending a slash
        return props.internalLink?.[0]?.uri.startsWith('/') 
            ? props.internalLink?.[0]?.uri
            : `/${props.internalLink?.[0]?.uri}`;
    }

    return props.internalLink;
});
</script>
